import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['field', 'selector']

  connect() {
    this.refresh();
  }

  refresh() {
    console.log(this.fieldTarget.value);

    if (this.fieldTarget.value) {
      this.selectorTarget.classList.add('d_n');
    } else {
      this.selectorTarget.classList.remove('d_n');
    }
  }

  set(event) {
    this.fieldTarget.value = event.currentTarget.text;
    this.refresh();
  }
}
